module.exports = __webpack_public_path__ + "img/footer-bg.4c74cbdf.jpg";